import config from '../config.json';
import {PlayerAction, encodeMessage} from '../common/connection/messages';

type ConnectCallback = () => void;
type MessageCallback = (data: string) => void;
type DisconnectCallback = (reconnectIn: number) => void;

class Connection {
    private sequenceNumber: number = 1;
    private ws: WebSocket;
    private onConnect: ConnectCallback;
    private onMessage: MessageCallback;
    private onDisconnect: DisconnectCallback;
    private isConnecting: boolean = false;
    private retryCount: number = 0;

    public connect(
        onConnect: ConnectCallback,
        onMessage: MessageCallback,
        onDisconnect: DisconnectCallback
    ): void {
        this.onConnect = onConnect;
        this.onMessage = onMessage;
        this.onDisconnect = onDisconnect;

        this.initializeWebSocket();
    }

    public send(action: PlayerAction, params: {}): boolean {
        if (this.ws.readyState === WebSocket.OPEN) {
            this.ws.send(encodeMessage(action, params, this.sequenceNumber));
            this.sequenceNumber += 1;
            return true;
        } else {
            this.reconnect();
            return false;
        }
    }

    public attemptReconnect(): void {
        this.retryCount = 0;
        this.reconnectNow();
    }

    private onmessage(event: MessageEvent): void {
        this.onMessage(event.data as string);
    }

    private onopen(): void {
        this.onConnect();
        this.isConnecting = false;
        this.retryCount = 0;
    }

    private onerror(_event: Event): void {
        if (this.isConnecting) {
            this.isConnecting = false;
            this.reconnect();
        }
    }

    private onclose(_event: Event): void {
        if (!this.isConnecting) {
            this.reconnect();
        }
    }

    private reconnect(): void {
        const delay = (2 ** this.retryCount - 1) * 1000;
        if (!this.isConnecting) {
            this.onDisconnect(delay);
        }
        // eslint-disable-next-line no-console
        console.log('reconnect', this.retryCount, delay);
        this.isConnecting = true;
        this.retryCount += 1;
        setTimeout(() => this.reconnectNow(), delay);
    }

    private reconnectNow(): void {
        if (this.ws.readyState === WebSocket.OPEN) return;
        this.ws.onopen = null;
        this.ws.onmessage = null;
        this.ws.onclose = null;
        this.ws.onerror = null;
        this.initializeWebSocket();
    }

    private initializeWebSocket(): void {
        this.ws = new WebSocket(config.serverWebsocketUrl);
        this.ws.binaryType = 'arraybuffer';
        this.ws.onopen = this.onopen.bind(this);
        this.ws.onmessage = this.onmessage.bind(this);
        this.ws.onclose = this.onclose.bind(this);
        this.ws.onerror = this.onerror.bind(this);
        this.isConnecting = true;
    }
}

export default new Connection();



// WEBPACK FOOTER //
// ./src/Connection/index.ts